import { getConfig } from '@helpers';

export default function useConfig() {
  return getConfig() ?? {};
}
